export default "__VITE_ASSET__a2cba443__"